/** Finishing a level — the learner's own milestone.
 *
 * Eligibility is computed by the server; the completion is CLAIMED by the
 * learner pressing a button. A level that ticked itself the moment the last
 * lesson was done would take the moment away from them.
 */
import { request } from "./http";

export interface LevelStatus {
  level: string;
  lessons_done: number;
  lessons_total: number;
  parts_practised: number;
  parts_total: number;
  /** Everything done — the button may be pressed. */
  eligible: boolean;
  /** Null until they press it. */
  completed_at: string | null;
}

export function myLevels(): Promise<LevelStatus[]> {
  return request<{ levels: LevelStatus[] }>("/levels/").then((r) => r.levels);
}

export function completeLevel(level: string): Promise<LevelStatus> {
  return request(`/levels/${level}/complete`, { method: "POST" });
}

export function uncompleteLevel(level: string): Promise<LevelStatus> {
  return request(`/levels/${level}/complete`, { method: "DELETE" });
}
